import { idologyQuestionnaires } from "@/api/myProfile";
import { trackApiCall, trackButtonClick } from "@/utils/analytics";
import React, { useState } from "react";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { trackEvent } from "@/utils/analytics";

const IdologyQuestions = ({
  handleClose,
  questions,
  ssn,
  dob,
  setQuestions,
  isFromAlerts,
  idoSuccess,
  setIdeologyError,
  isFromBid,
  parentComponent = "MyProfile",
}) => {
  const [currentQuestion, setCurrentQuestion] = useState(0);
  const [selectedAnswers, setSelectedAnswers] = useState(
    Array(questions.length).fill("")
  );
  const [showNext, setShowNext] = useState(false);
  const [isCompleted, setIsCompleted] = useState(false);
  const [error, setError] = useState("");
  const [accountLocked,setAccountLocked] = useState(false)

  const profileInfo = useSelector((state) => state.user.profileInfo);


  const closeIdologyModal = () => {
    handleClose();
  };

  const handleAnswerSelect = (answer) => {
    const newAnswers = [...selectedAnswers];
    newAnswers[currentQuestion] = answer;
    setSelectedAnswers(newAnswers);
    setShowNext(true);
  };

  const handleNext = () => {
    if (currentQuestion < questions.length - 1) {
      setCurrentQuestion(currentQuestion + 1);
      // setShowNext(false);
      setShowNext(!!selectedAnswers[currentQuestion + 1]);
    } else {
      setIsCompleted(true);
    }
  };
  const handlePrevious = () => {
    if (currentQuestion > 0) {
      setCurrentQuestion(currentQuestion - 1);
      // setShowNext(true);
      setShowNext(!!selectedAnswers[currentQuestion - 1]);
    }
  };

  const formatPayload = () => {
    const formData = new FormData();
    formData.append("ssn", ssn);
    formData.append("dob", dob);
    selectedAnswers.forEach((answer, index) => {
      formData.append(
        `idologyQuestionAnswers[${index}].type`,
        questions[index].type
      );
      formData.append(`idologyQuestionAnswers[${index}].answer`, answer);
    });

    return formData;
  };

  const handleSubmit = async () => {
    trackButtonClick({
      eventName: "idology_submit",
      eventCategory: isFromAlerts
        ? "globalAlertsIdology"
        : parentComponent === "GlobalAlerts"
        ? "globalAlertsIdology"
        : parentComponent === "MyProfile"
        ? "userDashboard"
        : parentComponent === "MyBid"
        ? "Bid/Offer wizard"
        : "",
      eventParams: {
        source: isFromAlerts ? "alerts" : parentComponent || "unknown",
      },
    });

    const payload = formatPayload();
    try {
      const data = await idologyQuestionnaires(payload);
      if (data?.status === "SUCCESS") {
        trackApiCall({
          eventName: "idology_verification_success",
          eventCategory: isFromAlerts
            ? "globalAlertsIdology"
            : parentComponent === "GlobalAlerts"
              ? "globalAlertsIdology"
              : parentComponent === "MyProfile"
                ? "userDashboard"
                : parentComponent === "MyBid"
                  ? "Bid/Offer wizard"
                  : "",
          eventParams: {
            idology_verification: "successful",
            source: isFromAlerts ? "alerts" : parentComponent || "unknown",
          },
        });

        if (profileInfo?.userDetails?.phoneNumberVerified === true) {
          trackEvent({
            name: "ready_to_bid",
            category: "New-Bid Wizard",
            eventSource: "on Ideology Verification",
            eventLabel: "",
          });
        }

        if (!isFromBid) {
          toast.success("Your profile is verified successfully.");
        }
        closeIdologyModal();
        idoSuccess();
      }
    if (data?.status === "errorIdologyIncorrectAnswers") {
    // resetAllStates()
    setCurrentQuestion(0);
    setSelectedAnswers([]);
    setIsCompleted(false);
    setShowNext(false);
      setError(`Please answer each question correctly in order to proceed. You have ${data?.idology?.remainingAttemptCount} more attempt before your account is locked. Please call Customer Care at (855) 882-1314 with questions or concerns.`);
        setQuestions(data?.idology?.questions);

    }
    if(data?.status === "errorIdologyAttemptsExceeded"){
      if(isFromAlerts || isFromBid){
        setIdeologyError("errorIdologyAttemptsExceeded")
        handleClose()

      }else{
        setAccountLocked(true)
      }
    }
    if(data?.status === "errorIdologySystemError"){
      const message = `We’re currently experiencing technical difficulties with the verification system.
          Please try again later or contact Customer Care at (855) 882-1314.`;
        setError(message);
        // setQuestions(data?.idology?.questions);

    }
    } catch (error) {
      toast.error(error)
    }
  };

  const resetAllStates = () => {
    if(isFromAlerts){
      handleClose()
    }else{
      setCurrentQuestion(0);
      setSelectedAnswers([]);
      setIsCompleted(false);
      setShowNext(false);
      setError("");
    }
  };
  return (
    <>
      {!isFromAlerts ? (
        <div className="idology-modal-header">
          <h4>Simple 4 Security Questions</h4>
          <button className="idology-close-button" onClick={closeIdologyModal}>
            ×
          </button>
        </div>
      ) : null}

      {accountLocked ? (
        <div className="fs-12 robo-light">
          Your account has been locked because you have failed the
          authentication process three times. Please contact Customer Care at
          (855) 882-1314 or customercare@hubzu.com for further assistance.
        </div>
      ) : (
        <div className="quiz-container">
          <div className="progress-indicators">
            {questions.map((_, index) => (
              <div key={index} className="progress-item">
                <div
                  className={`progress-circle ${
                    index === currentQuestion
                      ? "active"
                      : index < currentQuestion
                      ? "completed"
                      : ""
                  }`}
                >
                  {index < currentQuestion ? (
                    <span className="checkmark">✓</span>
                  ) : (
                    index + 1
                  )}
                </div>
                {index < questions.length - 1 && (
                  <div
                    className={`connector-line ${
                      index < currentQuestion ? "completed" : ""
                    }`}
                  />
                )}
              </div>
            ))}
          </div>
          {error?.length === 0 ? (
            <div className="mt-5 pt-3 ">
              <p className="text-center idology-question">
                <b>{questions[currentQuestion].prompt}</b>
              </p>

              <div
                className={`text-center my-4 ${
                  !isFromAlerts && !isFromBid
                    ? "mrml75"
                    : isFromBid
                    ? "mrml30p"
                    : ""
                }`}
              >
                {questions[currentQuestion].answers.map((answer, index) => (
                  <div
                    key={index}
                    className="d-flex justify-content-center my-2 py-2 idology-radio-label"
                  >
                    <input
                      type="radio"
                      id={`answer-${index}`}
                      name="quiz-answer"
                      value={answer}
                      checked={selectedAnswers[currentQuestion] === answer}
                      onChange={() => handleAnswerSelect(answer)}
                      className="mx-3"
                    />
                    <label
                      htmlFor={`answer-${index}`}
                      className="w-50 text-start ideology-label-bold"
                    >
                      {answer}
                    </label>
                  </div>
                ))}
              </div>
              <div className="pt-4 text-center">
                {currentQuestion > 0 && (
                  <button
                    className="nav-button previous-link"
                    onClick={handlePrevious}
                    aria-label="Previous question"
                  >
                    {`<Previous`}
                  </button>
                )}
                <button
                  disabled={
                    !(currentQuestion === 3 && selectedAnswers[currentQuestion])
                  }
                  onClick={handleSubmit}
                  className="submit-btn-idology hubzu-btn-thm mx-3"
                >
                  Submit
                </button>
                {showNext && currentQuestion < 3 && (
                  <button className="previous-link" onClick={handleNext}>
                    {`Next>`}
                  </button>
                )}
              </div>
            </div>
          ) : (
            <div className="">
              <p className="text-danger">Authentication Failed.</p>
              <p className="text-danger fs-12">{error}</p>
              <div className="text-center mt-4">
                <button
                  onClick={resetAllStates}
                  className="submit-btn-idology hubzu-btn-thm mx-3 text-center"
                >
                  Continue
                </button>
              </div>
            </div>
          )}
        </div>
      )}
    </>
  );
};

export default IdologyQuestions;
